import React from "react"

import Loading from "@irati/ui/src/Loading"

import {useOnce} from "../hooks/useOnce"
import {useLangLoaderActions, useLangLoader} from "./useLangLoader"

interface Props {
  bucket?: string | null
  buckets?: string[]
  children: React.ReactNode
}

export function LangLoader({bucket = null, buckets = [], children}: Props) {
  const bucketsToLoad = (bucket ? [bucket] : buckets).map((b) => b.toLowerCase())
  const ready = useLangLoader(bucketsToLoad)
  const {getContent} = useLangLoaderActions()

  useOnce(() => {
    getContent(bucketsToLoad)
  })

  return <Loading isLoading={!ready}>{children}</Loading>
}
